// extracted by mini-css-extract-plugin
export default {"success_modal":"email-confirmation_success_modal__XenbB"};